/**
 * Seeds Filter Dropdown Width Constants
 *
 * Defines custom widths for filter dropdowns to accommodate long text values.
 * Extracted from config/filters.ts for better organization.
 */

/**
 * Filter dropdown width configuration
 *
 * Defines custom widths for filters that need more space to display full text.
 * Filters not listed here will use the default width (400px).
 *
 * @example
 * ```tsx
 * const width = FILTER_DROPDOWN_WIDTHS.registrar; // 600
 * const defaultWidth = FILTER_DROPDOWN_WIDTHS.default; // 400
 * ```
 */
export const FILTER_DROPDOWN_WIDTHS = {
  /** Wide dropdown for long registrar names (e.g., "Domain Science Kutatasi Szolgaltato Kft") */
  registrar: 600,
  /** Wide dropdown for long email addresses */
  email: 800,
  /** Wide dropdown for long status names */
  status: 200,
  /** Standard width for tags filter */
  tags: 400,
  /** Default width for all other filters */
  default: 400,
} as const;
